export default __webpack_public_path__ + "static/media/shareiconreferralprofile.90ff1f58.svg";